export default {
  Community: {
    title: "Comunidad",
    description:
      "Intercambio de conocimientos entre médicos sobre casos clínicos",
    all_cases: "Todos los casos",
    my_cases: "Mis casos",
    case: {
      shareLink: {
        1: "Mira el caso",
        2: "en la Plataforma “" + process.env.VUE_APP_INSTALL_NAME + "”:",
      },
    },
  },
  h1_community: "Comunidad de médicos",
};
